export const env = { ...import.meta.env, ...window["env"] };
